import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ScreenType } from 'src/app/enums/ScreenType';
import { Visitor } from 'src/app/models/visitor';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import * as moment from 'moment';

@Component({
  selector: 'app-visitor-details-dialog',
  templateUrl: './visitor-details-dialog.component.html',
  styleUrls: ['./visitor-details-dialog.component.scss'],
})
export class VisitorDetailsDialogComponent {
  @Input() set visitorDetails(val: Visitor) {
    if (val) this.setVisitorDetails(val);
  }
  @Input() set isPopup(val: boolean) {
    if (!val) this.isPopDetails = val;
  }
  @Output() closeVisitorDetail = new EventEmitter<boolean>();
  @Output() showVisitorTimeline = new EventEmitter<any>();
  @Output() updateVisitorDetails = new EventEmitter<any>();

  @ViewChild('RemoveVisitorDialog', { static: true })
  removeVisitorDialog: TemplateRef<any>;
  isPopDetails = true;
  profilePicture = '';
  IdentityId = '';
  isShowTime = false;
  showVisitorDetailsForm = this.formbuilder.group({
    firstName: [''],
    lastName: [''],
    email: ['', [Validators.email]],
    phoneNumber: [''],
    visitorAddress: [''],
    visitorID: [''],
    purpose: [''],
    carRegistration: [],
    hostUserId: [''],
    hostEmail: [''],
    hostName: [''],
    visitDateTime: [''],
    gender: [''],
    checkIn: [''],
    checkOut: [''],
    ePassValidity: [''],
    visitorCategory: [''],
    newEPassValidity: [''],
    isActive: [''],
    securityStatus: [''],
  });
  screenSize: ScreenType;
  isUpdateVisitorDetails = false;
  isUpdatePassValidty = false;
  minDate: any;
  maxDate: any;
  currentYear: any;
  constructor(
    private formbuilder: FormBuilder,
    private screen: AumyeResponsiveScreenService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: Visitor
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
    this.setVisitorDetails(data);
  }
  setVisitorDetails(val: Visitor) {
    this.showVisitorDetailsForm.reset();
    this.showVisitorDetailsForm.controls.visitDateTime.setValue(
      moment(new Date(val.visitDateTime)).format('DD/MM/YYYY, h:mm:ss A')
    );
    if (val.checkIn) {
      this.showVisitorDetailsForm.controls.checkIn.setValue(
        moment(new Date(val.checkIn)).format('DD/MM/YYYY, h:mm:ss A')
      );
    } else {
      this.showVisitorDetailsForm.controls.checkIn.setValue('');
    }
    if (val.checkOut) {
      this.showVisitorDetailsForm.controls.checkOut.setValue(
        moment(new Date(val.checkOut)).format('DD/MM/YYYY, h:mm:ss A')
      );
    } else {
      this.showVisitorDetailsForm.controls.checkOut.setValue('');
    }
    this.showVisitorDetailsForm.controls.firstName.setValue(val.firstName);
    this.showVisitorDetailsForm.controls.lastName.setValue(val.lastName);
    this.showVisitorDetailsForm.controls.email.setValue(val.email);
    this.showVisitorDetailsForm.controls.phoneNumber.setValue(val.phoneNumber);
    this.showVisitorDetailsForm.controls.visitorAddress.setValue(
      val.visitorAddress
    );
    this.showVisitorDetailsForm.controls.visitorID.setValue(val.visitorID);
    this.showVisitorDetailsForm.controls.purpose.setValue(val.purpose);
    this.showVisitorDetailsForm.controls.carRegistration.setValue(
      val.carRegistration
    );
    this.showVisitorDetailsForm.controls.hostName.setValue(val.hostName);
    this.showVisitorDetailsForm.controls.visitorCategory.setValue(
      val.visitorCategory
    );
    this.showVisitorDetailsForm.controls.ePassValidity.setValue(
      moment(new Date(val.ePassValidity)).format('DD/MM/YYYY, h:mm:ss A')
    );
    this.currentYear = new Date(val.ePassValidity).getFullYear();
    this.minDate = new Date(
      this.currentYear + 0,
      new Date(val.ePassValidity).getMonth(),
      new Date(val.ePassValidity).getDate()
    );
    this.showVisitorDetailsForm.controls.securityStatus.setValue(
      val.securityStatus.toString()
    );
    this.maxDate = new Date(this.currentYear + 0, new Date().getMonth() + 6, 0);
    this.profilePicture = val.profilePicture;
    this.IdentityId = val.identityID;
    this.isShowTime = false;
  }
  onClose() {
    this.closeVisitorDetail.emit();
  }
  visitorTimelineToggle() {
    this.isShowTime = !this.isShowTime;
    this.showVisitorTimeline.emit(this.isShowTime);
  }
  toggleVisitorEdit() {
    if (this.isUpdateVisitorDetails) {
      this.updateVisitorDetails.emit(this.showVisitorDetailsForm.value);
    } else this.isUpdateVisitorDetails = true;
  }
  togglePassValidity() {
    this.isUpdatePassValidty = !this.isUpdatePassValidty;
  }
  onRemoveVisitor() {
    const dialogref = this.dialog.open(this.removeVisitorDialog, {
      disableClose: true,
    });
    dialogref.afterClosed().subscribe((result: any) => {
      if (result) {
        this.showVisitorDetailsForm.controls.isActive.setValue('0');
        this.updateVisitorDetails.emit(this.showVisitorDetailsForm.value);
      }
    });
  }
  ScreenType = ScreenType;
}
